<template>
  <div class="car-page" v-cloak>
    <div class="car-header">
      <p class="car-header-title">
        <span class="title">购物车</span>
        <span v-if="productList.length > 0 && isEdit == true" @click="onIsEdit">编辑</span>
        <span v-if="productList.length > 0 && isEdit == false" @click="onIsEdit">完成</span>
      </p>
      <p class="car-header-tips">您购物车有{{productList.length}}个产品</p>
    </div>

    <!-- 列表 -->
    <div class="list">
      <van-list v-model="loading" :immediate-check="true" :finished="finished" finished-text="没有更多了" @load="getInit">

        <div class="img-text-row" v-for="(item, index) in productList" :key="index">
          <div class="radio" @click="setType(index, item)">
            <img :src="item.checked? radio_active_icon : radio_icon" />
          </div>

          <div class="row-goods-img" @click="setType(index, item)">
            <img :src="item.goods_pic" alt="" />
          </div>

          <!-- <div class="danger" @click="setType(index, item)" v-if="!item.state">已下架</div> -->

          <div class="row-goods-info">
            <p class="row-goods-name van-multi-ellipsis--l2" @click="goDetails(index, item)">{{ item.goods_name }}</p>
            <!-- <p class="row-goods-des" @click="goDetails(index, item)">{{ item.description }}</p> -->
            <p class="row-goods-des" @click="goDetails(index, item)">
              <van-tag color="#F9F9F9" text-color="#BBBBBB">{{ item.sku_spec }}</van-tag>
            </p>
            <p class="row-goods-original-price" @click="goDetails(index, item)">市场价{{ item.market_price }}</p>
            <p class="row-goods-price"><span @click="goDetails(index, item)">¥ {{ item.goods_price }}</span>
              <van-stepper v-model="item.goods_num" theme="round" button-size="22" :name="item.id" disable-input @minus="editQuantity(item,item.id,item.goods_num-1)" @plus="editQuantity(item,item.id,item.goods_num+1)" />
            </p>

          </div>
        </div>

      </van-list>
    </div>

    <van-empty class="custom-image" v-if="productList.length< 1" image="https://qiniu.zdyxjx.com/v3/pic/9aa31c39fa354c90a40facda1727a33d.png" />
    <!-- 购买底部 -->
    <van-submit-bar v-if="productList.length > 0  && isEdit == true " :price="totalMoney" button-text="提交订单" button-color="#ff5000" :suffix-label="'共'+totalNum+'件'" @submit="onSubmit" :safe-area-inset-bottom="true">
      <van-checkbox style="margin-right:5px;" v-model="checkAll">全选</van-checkbox>
    </van-submit-bar>

    <!-- 编辑底部 -->
    <div class="car-foot-block" v-if="productList.length > 0  && isEdit == false ">
      <van-checkbox style="margin-right:5px;" v-model="checkAll">全选</van-checkbox>

      <div class="car-foot-btn">
        <!-- <van-button plain round color="#03A7BF" size="small" style="margin-right:15px;" @click="setCollection">加入收藏</van-button> -->
        <van-button plain round color="#E95970" size="small" @click="deleteGoods">删除产品</van-button>
      </div>
    </div>

  </div>
</template>

<script type="text/babel">
import { getToken, setToken, removeToken } from "@/utils/auth";
export default {
  name: "shopping-car",
  components: {},
  props: {},
  data() {
    return {
      isEdit: true, // 是否编辑
      checkAll: false,
      active: -1,
      radio_icon: require("../../assets/icon/radio.png"), //radio
      radio_active_icon: require("../../assets/icon/radio-active.png"), //radio active

      pageNum: 1,
      pageSize: 10,
      loading: true,
      finished: false,
      //商品
      productList: [
        // {
        //   productId: "12131",
        //   name: "乐扣乐扣-莹彩蓝轻量保温杯",
        //   imageUrl: "http://qiniu.zdyxjx.com/product/upload_pic_1608275023065",
        //   description: "乐扣乐扣-莹彩蓝轻量保温杯",
        //   showPrice: 100.00,
        //   goods_price: 0.0,
        //   costPrice: 100.00,
        //   state: 1,
        //   checked: false,
        // },
      ],

      totalMoney: 0.0, //合计现金总额
      totalNum: 0, //合计数量
    };
  },
  watch: {
    checkAll: {
      handler(newValue, oldValue) {
        console.log(newValue, oldValue);
        if (newValue) {
          this.productList.map((item, index) => {
            item.checked = true;
          });
        } else {
          this.productList.map((item, index) => {
            item.checked = false;
          });
        }
        this.count(); //计算总价
      },
      deep: true, // 深度监听表单
    },
    productList: {
      handler(newValue, oldValue) {
        // console.log(newValue, oldValue);
        this.count(); //计算总价
      },
      deep: true, // 深度监听表单
    },
  },
  created() {},
  mounted() {
    //  是否登陆过
    if (this.isLogin()) {
      console.log("已登录");
      this.getInit();
      this.count(); //计算总价
    } else {
      console.log("未登录");
      this.loading = false;
      this.finished = true;
    }
  },
  methods: {
    // 获取购物车列表
    getInit() {
      let _this = this;

      this.$toast.loading();
      let data = {
        // special_id: _this.pageId, // 分组ID
        page: _this.pageNum,
        limit: _this.pageSize,
      };
      _this.$post("/api/cart_list", data, data).then((res) => {
        console.log(res.data);
        _this.loading = false; // 加载状态结束

        if (res.data.code == 0) {
          // console.log(res.data.data);

          let lists = res.data.data;

          if (lists && lists.length > 0) {
            lists = lists.map((item, index) => {
              return Object.assign({}, item, { checked: false });
            });

            // console.log(lists)

            if (_this.pageNum == 1) {
              _this.productList = [];
              _this.productList = lists;
            } else {
              _this.productList = _this.productList.concat(lists);
            }
            _this.pageNum++;
            if (lists.length < _this.pageSize) {
              _this.finished = true; // 数据全部加载完成
            }
          } else {
            _this.finished = true; // 数据全部加载完成
          }
          _this.$toast.clear();
        } else if( res.data.code == -10004){
          _this.finished = true;
          sessionStorage.clear(); //清除数据
          Lockr.rm("userId");
          Lockr.rm("mobile");
          Lockr.rm("headImgUrl");
          Lockr.rm("user_nickname");
          removeToken();
          _this.isLogin()
        } else {
          _this.$toast.fail(res.data.message);
          _this.finished = true;
        }
      });
    },
    // 选择
    setType(ind, e) {
      // this.productList[ind].checked = true;
      // console.log(e)
      e.checked = !e.checked;
      // this.count() //计算总价
    },
    // 修改购物车商品数量~
    editQuantity(item, cart_id, value) {
      console.log(item, cart_id, value);
      let _this = this;
      let data = {
        cart_id: cart_id,
        goods_num: value,
      };
      this.$post(`/api/change_cart_num`, data, data).then((res) => {
        // console.log(res);
        if (res.data.code != 0) {
          _this.$toast.fail(res.data.message);
        }
      });
    },
    // 跳商品详情
    goDetails(ind, e) {
      this.$router.push({ path: `/product-details/${e.goods_id}` });
      // this.$router.push({
      //   name: 'product-details',
      //   query: {
      //     productId: e.productId
      //   },
      // });
    },
    // 下单
    onSubmit() {
      let _this = this;
      // 判断是否包含以下架商品·
      // console.log(this.payProving())
      // if (this.payProving() > 0) {
      //   this.$toast.fail('包含以下架商品，无法提交订单。');
      //   return;
      // }
      // map 赋值已经选择的商品~
      let listss = [];
      _this.productList.map((item, index) => {
        if (item.checked) {
          listss.push({
            cart_id: item.id || "0",
            goods_name: item.goods_name, //商品名称
            activity_type: 1, // 类型；1普通 2礼券 3积分 4兑换
            express_price: item.express_price || 0, // 快递费
            pic: item.goods_pic, // 主图片
            brand_name: "", // 品牌名称
            province_name: "", // 所在省
            city_name: "", // 所在市
            market_price: item.market_price, //市场价
            shop_price: item.goods_price, //价格
            sku_id: item.sku_id, //价格
            spec_value: item.sku_spec, //sku
            goods_id: item.goods_id, //价格
            amount: item.goods_num, //数量
            stock: item.stock, //库存
          });
        }
      });

      // console.log(listss)
      // 判断是否为空
      if (listss.length < 1) {
        this.$toast.fail("请选择商品！");
        return;
      }
      // 存储数据
      Lockr.set("goodsInfo", listss);
      // 跳转到下单页
      this.$router.push({
        name: "confirm-order",
        query: {
          // productId: this.productId,
        },
      });
    },
    payProving() {
      let _this = this;
      let a = 0;
      this.productList.map((item, index) => {
        if (item.checked && !item.state) {
          a += 3;
        } else {
          a += 0;
        }
      });
      return a;
    },
    // 收藏按钮
    setCollection() {
      // this.$toast.success('点击收藏')
      let _this = this;
      let idList = [];
      this.productList.map((item, index) => {
        if (item.checked == true) {
          idList.push(item.productId);
        }
      });
      // console.log(idList)
      this.$post("/product/api/Wish", { productId: idList }).then((res) => {
        // console.log(res);
        if (res.data.code == 200) {
          _this.$toast("收藏成功");
        } else {
          this.$toast.fail(res.data.message);
        }
      });
    },
    // 删除按钮
    deleteGoods() {
      let _this = this;
      let data = {
        cart_id: undefined,
      };
      this.productList.map((item, index) => {
        if (item.checked == true) {
          // idList.push(item.id);
          if (data.cart_id) {
            data.cart_id = data.cart_id + "," + item.id;
          } else {
            data.cart_id = item.id;
          }
        }
      });
      console.log(data.cart_id);
      // let data =qs.stringify({'id': idList }, { arrayFormat: 'repeat' })
      // this.$delete("/product/api/ShoppingCart?"+data, ).then((res) => {
      // let data = idList.map((it) => `id=${it}`).join("&");
      this.$post(`/api/del_cart`,data,data).then((res) => {
        // console.log(res);
        if (res.data.code == 0) {
          let listss = [];
          _this.productList.map((item, index) => {
            if (item.checked == false) {
              listss.push(item);
            }
          });
          _this.productList = listss;
          // console.log(_this.productList)
          _this.$toast("删除成功");
        } else {
          this.$toast.fail(res.data.message);
        }
      });
    },
    // 顶部是否编辑
    onIsEdit() {
      this.isEdit = !this.isEdit;
    },

    count() {
      let totalInd = 0;
      let totalPrice = 0;

      this.productList.map((item, index) => {
        if (item.checked == true) {
          // console.log(item)
          totalPrice += item.goods_price * item.goods_num;
          totalInd++;
        }
        // skuItem.push({ skuId: item.skuId, goods_num: item.goods_num })
      });

      // console.log(totalPrice, totalInd)
      this.totalMoney = totalPrice * 100;
      this.totalNum = totalInd;
      // console.log(skuItem)
      //  this.shoppingOrderCreateParams.paymentAmount = Math.round(this.shoppingOrderCreateParams.paymentAmount * 100) / 100;
    },
  },
};
</script>
<style lang="scss">
.car-page {
  .van-submit-bar {
    bottom: 50px;
    .van-checkbox__icon--checked {
      .van-icon {
        background-color: #ff5000 !important;
        border-color: #ff5000 !important;
      }
    }
  }
  .car-foot-block {
    .van-checkbox__icon--checked {
      .van-icon {
        background-color: #ff5000 !important;
        border-color: #ff5000 !important;
      }
    }
  }
  .van-stepper {
    .van-stepper__minus {
      color: #ff510093 !important;
      border-color: #ff510093 !important;
    }
    .van-stepper__minus--disabled {
      color: #666666 !important;
      border-color: #666666 !important;
    }
    .van-stepper__plus {
      background-color: #ff510093 !important;
    }
  }
  // 空状态
  .custom-image .van-empty__image {
    width: 260px;
    height: 300px;
  }
}
</style>
<style lang="scss" scoped>
.car-page {
  // height: 100%;
  width: 100%;
  background-color: #f9f9f9;
  padding: 65px 0 100px;
  // 顶部
  .car-header {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 64px;
    background-color: #fff;
    z-index: 9;
    box-shadow: 0px 5px 5px rgba(120, 132, 158, 0.16);
    padding: 0 20px;
    .car-header-title {
      display: flex;
      align-items: center;
      justify-content: space-between;

      font-size: 18px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      line-height: 41px;
      color: #2a2e43;
      letter-spacing: 1px;
      .title {
        font-size: 24px;
        font-weight: 600;
      }
    }
    .car-header-tips {
      text-align: left;
      font-size: 12px;
      font-family: Source Han Sans CN;
      font-weight: 500;
      line-height: 21px;
      color: #78849e;
      letter-spacing: 2px;
    }
  }
  // //底部
  .car-foot-block {
    position: fixed;
    bottom: 50px;
    left: 0;
    height: 50px;
    width: 100%;
    background-color: #fff;
    box-shadow: 0px -2px 5px rgba(120, 132, 158, 0.16);
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 15px;

    font-size: 14px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    line-height: 26px;
    color: #2a2e43;
    .car-foot-btn {
      font-size: 12px;
      font-family: Source Han Sans CN;
      font-weight: 500;
      line-height: 21px;
      color: #ff5000;
      // width: 100px;
      height: 100%;
      display: flex;
      align-items: center;
      // background-color: palegoldenrod;
    }
  }
  // 横向
  .img-text-row {
    width: 100%;
    height: 150px;
    background-color: #fff;
    //  background-color: palegoldenrod;
    margin-bottom: 10px;
    padding: 5px 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    position: relative;

    .danger {
      position: absolute;
      top: 0;
      left: 0;
      z-index: 1;
      width: 100%;
      height: 100%;
      font-size: 18px;
      color: #fff;
      background-color: rgba(0, 0, 0, 0.2);
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .radio {
      width: 18px;
      height: 18px;
      //   background-color: #eee;

      img {
        width: 100%;
        height: 100%;
      }
    }
    .row-goods-img {
      width: 140px;
      height: 140px;
      img {
        width: 100%;
        height: 100%;
      }
    }

    .row-goods-info {
      width: 190px;
      height: 100%;
      padding: 5px 0;
      text-align: left;
      //  background-color: paleturquoise;

      .row-goods-leble {
        font-size: 10px;
        font-family: Source Han Sans CN;
        font-weight: 500;
        line-height: 17px;
        color: #ffffff;
        letter-spacing: 1px;
        text-align: left;

        span {
          padding: 1px 7px;
          border-radius: 3px;
        }

        .rx {
          background-color: #e95970;
        }
        .xs {
          margin-left: 3px;
          background-color: #b80009;
        }
      }
      .row-goods-name {
        font-size: 13px;
        font-family: Source Han Sans CN;
        font-weight: 500;
        // line-height: 30px;
        color: #333333;
        letter-spacing: 1px;
        // display: -webkit-box; /*作为弹性伸缩盒子模型显示*/
        // -webkit-line-clamp: 1; /*显示的行数；如果要设置2行加...则设置为2*/
        // overflow: hidden; /*超出的文本隐藏*/
        // text-overflow: ellipsis; /* 溢出用省略号*/
        // -webkit-box-orient: vertical; /*伸缩盒子的子元素排列：从上到下*/
      }
      .row-goods-des {
        font-size: 12px;
        font-family: Source Han Sans CN;
        font-weight: 500;
        line-height: 20px;
        color: #78849e;
        letter-spacing: 1px;
        display: -webkit-box; /*作为弹性伸缩盒子模型显示*/
        -webkit-line-clamp: 1; /*显示的行数；如果要设置2行加...则设置为2*/
        overflow: hidden; /*超出的文本隐藏*/
        text-overflow: ellipsis; /* 溢出用省略号*/
        -webkit-box-orient: vertical; /*伸缩盒子的子元素排列：从上到下 锐杰*/
      }
      .row-goods-class {
        font-size: 12px;
        font-family: Source Han Sans CN;
        font-weight: 500;
        line-height: 20px;
        color: #78849e;
        letter-spacing: 1px;
      }
      .row-goods-original-price {
        text-decoration: line-through;
        font-size: 10px;
        font-family: Source Han Sans CN;
        font-weight: 500;
        margin-top: 5px;
        line-height: 17px;
        color: #cccccc;
      }
      .row-goods-price {
        font-size: 18px;
        font-family: Source Han Sans CN;
        font-weight: 500;
        line-height: 30px;
        margin-top: 5px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        span {
          font-size: 15px;
          font-family: Source Han Sans CN;
          font-weight: 500;
          line-height: 17px;
          color: #ff5000;
        }
      }
    }
  }
}
</style>
